import { render } from "./InputUI.vue?vue&type=template&id=0d0db8e7&scoped=true"
import script from "./InputUI.vue?vue&type=script&lang=js"
export * from "./InputUI.vue?vue&type=script&lang=js"

import "./InputUI.vue?vue&type=style&index=0&id=0d0db8e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0db8e7"]])

export default __exports__